import getCdnBcIoImg from '@/shared/cdn/getCdnBcIoImg';

const BcIoCdn = {
  crown: getCdnBcIoImg('crown.png'),
  lightning: getCdnBcIoImg('lightning.png'),
  shield: getCdnBcIoImg('shield.png'),
};

export default BcIoCdn;
